import IdpHandler from './IdpHandler';

// User object
export default class User {
  static isLogged() {
    return (async () => {
      const idp = await IdpHandler.waitIdpReady();
      return await idp.isFanLoggedIn();
    })();
  }

  static get logged() {
    return this.isLogged();
  }

  static get Data() {
    if (!this.logged) return null;

    return IdpHandler.user;
  }

  static async getToken() {
    const idp = await IdpHandler.waitIdpReady();
    return idp.getAccessToken();
  }

  static get userId() {
    if (!this.Data) return null;
    return this.Data.userId;
  }

  static get userToken() {
    return (async () => {
      const idp = await IdpHandler.waitIdpReady();
      if (!this.Data) return null;

      return await idp.getTokens();
    })();
  }

  static get newsletters() {
    //TO DO
    return null;
  }

  static getIsSubscribed(_newsletterId?: string) {
    if (!this.Data) return null;
    //TO DO
    return null;
  }

  static getFollowedClubIds() {
    if (!this.Data) return null;

    // TO DO
    return null;
  }

  static getFollowedTeamIds() {
    if (!this.Data) return null;

    return this.Data.teams_followed;
  }

  static getFavouriteTeamCode() {
    if (!this.Data) return null;

    return this.Data.national_team_men;
  }

  static getFavouriteWomenTeam() {
    if (!this.Data) return null;

    return this.Data.national_team_women;
  }

  static getFavouriteClubId(_comp: string) {
    if (!this.Data) return null;

    // TO DO
    return null;
  }

  static setFollowedClub(_clubId?: string) {
    if (!this.logged) return;

    // TO DO
    return null;
  }

  static async setFavouriteTeam(teamId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.national_team_men.push(Number(teamId));
    return await idp.updateFan(this.Data);
  }

  static async setFavouriteWomenTeam(teamId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.national_team_women.push(Number(teamId));
    return await idp.updateFan(this.Data);
  }

  static async setFavouriteClub(clubId: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.club_men.push(Number(clubId));
    return await idp.updateFan(this.Data);
  }

  static async setFavouriteClubWomen(clubId: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.club_women.push(Number(clubId));
    return await idp.updateFan(this.Data);
  }

  static setFollowedTeam(_teamCode?: string) {
    if (!this.logged) return;

    // TO DO
    return null;
  }

  static async removeFavouriteTeam() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.national_team_men = null;
    return idp.updateFan(this.Data);
  }

  static async removeFavouriteWomenTeam() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    this.Data.national_team_women = null;
    return idp.updateFan(this.Data);
  }

  static removeFavouriteClub(_comp: string) {
    if (!this.logged) return;

    // TO DO
    return null;
  }

  static removeFollowedClub(_clubId?: string) {
    if (!this.logged) return;

    // TO DO
    return null;
  }

  static removeFollowedTeam(_teamCode?: string) {
    if (!this.logged) return;

    // TO DO
    return null;
  }
}
